import "../styles/filter-dropdown.scss";
import React, { useEffect } from "react";
import { GuiSelect } from "./global-ui/gui-select";
import { GuiButton } from "./global-ui/gui-button";
import { useUpdateState } from "../utilities/utilities";
import { Modal } from "./modal";

export function FilterPopup({
  filters,
  onFilterChange,
  onClose,
  selectedValues,
}) {
  let [state, updateState] = useUpdateState({});

  useEffect(() => {
    if (selectedValues !== undefined) {
      let updatedState = {};
      filters.forEach((f) => {
        updatedState[f.name] =
          selectedValues.find((s) => s.name === f.name) || null;
      });
      updateState(updatedState);
    }
  }, [selectedValues, filters]);

  function clearFilters() {
    onClose();
    onFilterChange("clear");
  }

  function applyFilter() {
    onClose();
    let values = [];
    filters
      .filter((f) => state[f.name])
      .forEach((f) => values.push({ name: f.name, ...state[f.name] }));
    onFilterChange("add-filters", values);
  }

  return (
    <>
      <Modal className="filter-popup"
      onClose={onclose}
      >
        <div className="filter-popup-header">
          <span>Filter</span>
          <i className="fa fa-close" onClick={onClose}></i>
        </div>
        <div className="filter-popup-body">
          {filters.map((f, i) => (
            <GuiSelect
              key={i}
              label={f.name}
              name={f.name}
              options={f.options}
              value={state[f.name]?.value || null}
              onChange={updateState}
            />
          ))}
        </div>

        <div className="filter-popup-footer">
          <GuiButton className="btn-outline" onClick={clearFilters}>
            Clear
          </GuiButton>

          <GuiButton onClick={applyFilter}>Apply</GuiButton>
        </div>
      </Modal>
    </>
  );
}
